/**
 * @author        yewon@zumper.com (Yewon Lee)
 * @copyright     Copyright (c) 2017, Zumper
 * @description   constant variable to be used for Actions
 */

export const SEARCH_VIEW_TYPE = {
  FAVORITES: 'favorites',
  MAIN: 'main',
  MESSAGED: 'messaged',
  SAVE_SEARCH_CREATE: 'save_search_create',
  SEARCHES: 'searches',
}

export const TOGGLE_MODAL = 'TOGGLE_MODAL'
export const UPDATE_LOCATION = 'UPDATE_LOCATION'
export const RESTORE_STATE = 'RESTORE_STATE'

/* LOCALSTORAGE */
export const RECEIVE_LOCALIZER_VALUES = 'RECEIVE_LOCALIZER_VALUES'

/* LOCAL USER */
export const SET_LOCAL_USER = 'SET_LOCAL_USER'

/* BUTTER BAR */
export const ADD_BUTTER_BAR = 'ADD_BUTTER_BAR'
export const REMOVE_BUTTER_BAR = 'REMOVE_BUTTER_BAR'

/* BUNDLE */
export const ADD_TO_FAVORITES = 'ADD_TO_FAVORITES'
export const CLEAR_BUNDLE = 'CLEAR_BUNDLE'
export const CONVERT_LOCAL_FAVORITES = 'CONVERT_LOCAL_FAVORITES'
export const ON_MESSAGE_SENT = 'ON_MESSAGE_SENT'
export const SET_USER = 'SET_USER'
export const REMOVE_FROM_FAVORITES = 'REMOVE_FROM_FAVORITES'
export const SET_BUNDLE = 'SET_BUNDLE'

/* CLUSTERS */
export const SET_VISITED = 'SET_VISITED'
export const RESET_CLUSTERS_AND_LISTABLES = 'RESET_CLUSTERS_AND_LISTABLES'

/* CITY */
export const GET_MCITIES_REQUEST = 'GET_MCITIES_REQUEST'
export const GET_MCITIES_SUCCESS = 'GET_MCITIES_SUCCESS'
export const GET_MCITIES_ERROR = 'GET_MCITIES_ERROR'
export const RESET_MCITIES = 'RESET_MCITIES'
export const SET_LAST_AUTOCOMPLETE_METRO = 'SET_LAST_AUTOCOMPLETE_METRO'

/* LISTABLES */
export const GET_LISTABLES_REQUEST = 'GET_LISTABLES_REQUEST'
export const GET_LISTABLES_SUCCESS = 'GET_LISTABLES_SUCCESS'
export const GET_LISTABLES_ERROR = 'GET_LISTABLES_ERROR'
export const RESET_LISTABLES = 'RESET_LISTABLES'
export const GET_LISTABLES_COUNTS_BY_REQUEST = 'GET_LISTABLES_COUNTS_BY_REQUEST'
export const GET_LISTABLES_COUNTS_BY_SUCCESS = 'GET_LISTABLES_COUNTS_BY_SUCCESS'
export const GET_LISTABLES_COUNTS_BY_ERROR = 'GET_LISTABLES_COUNTS_BY_ERROR'
export const SET_LISTABLES_LIMIT = 'SET_LISTABLES_LIMIT'
export const SET_LISTABLES_OFFSET = 'SET_LISTABLES_OFFSET'
export const SET_LISTABLES_PAGE_OFFSET = 'SET_LISTABLES_PAGE_OFFSET'
export const INCREMENT_LOAD_MORE_COUNT = 'INCREMENT_LOAD_MORE_COUNT'

/* LIST */
export const ON_REMOVE_ITEM_FROM_LIST = 'ON_REMOVE_ITEM_FROM_LIST'

/* SEARCH UI */
export const SET_HOVERED_ITEM = 'SET_HOVERED_ITEM'
export const SET_HOVERED_CLUSTER_ITEM = 'SET_HOVERED_CLUSTER_ITEM'
export const UPDATE_SEARCH_UI = 'UPDATE_SEARCH_UI'
export const SET_FILTERS_VIEW_START_POINT = 'SET_FILTERS_VIEW_START_POINT'
export const CLEAR_FILTERS_VIEW_START_POINT = 'CLEAR_FILTERS_VIEW_START_POINT'
export const SET_IS_FILTERS_VIEW = 'SET_IS_FILTERS_VIEW'

/* SITEMAP */
export const SET_SITEMAP = 'SET_SITEMAP'

// CITIES
export const GET_CITIES_REQUEST = 'GET_CITIES_REQUEST'
export const GET_CITIES_SUCCESS = 'GET_CITIES_SUCCESS'
export const GET_CITIES_ERROR = 'GET_CITIES_ERROR'
export const CLEAR_CITIES = 'CLEAR_CITIES'

// HOODS
export const GET_HOODS_REQUEST = 'GET_HOODS_REQUEST'
export const GET_HOODS_SUCCESS = 'GET_HOODS_SUCCESS'
export const CLEAR_HOOD = 'CLEAR_HOOD'

// MINHOODS
export const CURRENT_SEARCH_MHOOD = 'CURRENT_SEARCH_MHOOD'

/* PRICE DATA */
export const GET_PRICE_DATA_REQUEST = 'GET_PRICE_DATA_REQUEST'
export const GET_PRICE_DATA_SUCCESS = 'GET_PRICE_DATA_SUCCESS'
export const GET_PRICE_DATA_ERROR = 'GET_PRICE_DATA_ERROR'
